import React from "react";
import { Tooltip } from "@material-ui/core";
import { capitalize, get } from "lodash";

const ObjectiveComment = ({ colProps }) => {
  return (
    <td style={colProps.style} className={colProps.className}>
      <Tooltip
        placement="bottom-start"
        title={get(colProps, "dataItem.comment", "")}
      >
        <span className="truncate-txt">
          {capitalize(get(colProps, "dataItem.comment", ""))}
        </span>
      </Tooltip>
    </td>
  );
};

export default ObjectiveComment;
